import React from 'react';
import Img from 'gatsby-image';

/**
 * Wrapper component that automatically applies common image classes
 * Handles both 'pic' and 'bigger-size pic' patterns
 */
const ImageWrapper = ({ 
  fluid, 
  size = 'normal',
  className = '',
  loading = 'eager',
  wrapper = false,
  wrapperClassName = 'pic-wrapper'
}) => {
  const imageClasses = ['pic'];
  
  if (size === 'big') {
    imageClasses.push('bigger-size');
  }
  
  if (className) {
    imageClasses.push(className);
  }

  const imageElement = (
    <Img
      className={imageClasses.join(' ')}
      fluid={fluid}
      loading={loading}
    />
  );

  if (wrapper) {
    return (
      <div className={wrapperClassName}>
        {imageElement}
      </div>
    );
  }

  return imageElement;
};

export default ImageWrapper;